import classnames from 'classnames';
import React from 'react';

const Title = (props) => {
  const { pending, title } = props;

  const modifier = pending ? 'stepper__step-title--pending' : null;
  const className = classnames(
    'stepper__step-title',
    modifier,
  );

  return (
    <div className={className}>{title}</div>
  );
};

export default Title;
